import { Button, Flex, IconPlus, Stack, Text, Tooltip } from '@vtex/admin-ui'
import { BudgetPermissions, useBudgetContext } from 'hooks'
import { useMemo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { messages } from '../messages'
import { showTooltip } from '../shared/showTooltip'

type Props = {
  onAdd: () => void
  isAllowedDiscountType: boolean
}

export function BudgetEmptyView(props: Props) {
  const { onAdd, isAllowedDiscountType } = props

  const { $t } = useIntl()

  const { permission } = useBudgetContext()

  const textTooltip = useMemo(
    () =>
      permission !== BudgetPermissions.WRITE
        ? $t(messages.unauthorizedWrite)
        : $t(messages.disabled.addTooltip),
    [$t, permission]
  )

  return (
    <Stack space="$space-1" fluid>
      <Flex align="center" justify="space-between">
        <Text variant="title1">
          <FormattedMessage {...messages.title} />
        </Text>
        <Tooltip
          text={textTooltip}
          {...showTooltip(
            permission !== BudgetPermissions.WRITE || !isAllowedDiscountType
          )}
        >
          <div>
            <Button
              icon={<IconPlus />}
              variant="neutralTertiary"
              aria-label={$t(messages.add)}
              disabled={
                !isAllowedDiscountType || permission !== BudgetPermissions.WRITE
              }
              onClick={onAdd}
            />
          </div>
        </Tooltip>
      </Flex>
      <Text variant="body" tone="secondary">
        <FormattedMessage {...messages.description} />
      </Text>
    </Stack>
  )
}
